import * as msal from '@azure/msal-browser';
import { api, saml, msalClientId, msalAuthority, msalRedirectUri } from '../../../bootstrap.json';
import { resolveOtpParams } from '../auth.utils';
import { LOADING } from '../../navigation/navigation.actions.types';

const msalObj = new msal.PublicClientApplication({
    auth: {
        clientId: msalClientId,
        authority: msalAuthority,
        redirectUri: msalRedirectUri,
    },
});

/**
 * Creates a new AuthLoginController.
 * @class
 */
class AuthLoginController {
    constructor($log, $ngRedux, $state, $filter, $uiRouterGlobals, AuthService, AppService) {
        this.$log = $log;
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$filter = $filter;
        this.$uiRouterGlobals = $uiRouterGlobals;
        this.AuthService = AuthService;
        this.AppService = AppService;
    }

    $onInit() {
        this.$log.debug('Login::init');
        this.username = null;
        this.password = null;

        if (this.$state.params.message) {
            this.headlineClass = 'md-headline-success';
            this.headline = this.$state.current.params.headline;
        }
        else this.initHeadline();

        if (this.$uiRouterGlobals.params.reset)
            this.$ngRedux.dispatch({ type: 'RESET' });
    }

    onEntraID() {
        saml === 'true' ? this.onEntraSAML() : this.onEntraOIDC();
    }

    onEntraSAML() {
        this.initHeadline();
        this.$ngRedux.dispatch({ type: LOADING, data: true });
        this.AuthService.loginWithEntraSAML().then(({ data }) => {
            const width = 485;
            const height = 600;
            const left = (screen.width / 2) - (width / 2);
            const top = (screen.height / 2) - (height / 2);
            const popup = window.open(
                data,
                'Entra ID Login',
                `width=${width},height=${height},top=${top},left=${left}`,
            );
            const timer = setInterval(() => {
                if (popup.closed) {
                    clearInterval(timer);
                    this.$ngRedux.dispatch({ type: LOADING, data: false });
                }
            }, 500);
            window.addEventListener('message', (event) => {
                if (event.origin !== api) {
                    return;
                }
                if (event.data) {
                    this.AuthService.createSession(event.data);
                    this.$ngRedux.dispatch({ type: LOADING, data: false });
                    this.AppService.moduleOverride();
                    this.AuthService.recoverSession();
                }
            });
        }).catch(this.resolveError.bind(this));
    }

    onEntraOIDC() {
        this.initHeadline();
        this.$ngRedux.dispatch({ type: LOADING, data: true });
        msalObj.loginPopup({
            scopes: ['user.read', 'email'],
        }).then(({ idToken }) => {
            this.AuthService.loginWithEntraID(idToken).then(() => {
                this.$ngRedux.dispatch({ type: LOADING, data: false });
                this.AppService.moduleOverride();
                this.AuthService.recoverSession();
            }).catch(this.resolveError.bind(this));
        }).catch(this.resolveError.bind(this));
    }

    signIn() {
        this.initHeadline();
        if (this.loginForm.$valid) {
            this.$ngRedux.dispatch({ type: 'LOADING_START' });
            this.AuthService.login(this.username, this.password).then(() => {
                this.$ngRedux.dispatch({ type: 'LOADING_END' });
                this.AppService.moduleOverride();
                this.AuthService.recoverSession();
            }, ({ status, data }) => {
                this.$ngRedux.dispatch({ type: 'LOADING_END' });
                this.headlineClass = 'md-headline-error';
                switch (status) {
                    case 428:
                        /** Precondition Required */
                        this.$state.go('login.otp', {
                            token: data.token,
                            ...resolveOtpParams(data.status),
                        });
                        break;
                    case 429:
                        /** Too Many Requests */
                        this.headline = `COMMON.LOGIN.YOU_HAVE_HIT_MAX_NUM_OF_LOGIN_ATTEMPTS_ALLOWED`;
                        this.headlineDetail = this.$filter('translate')('COMMON.LOGIN.TRY_AGAIN_IN', { time: data });
                        break;
                    default:
                        switch (data.status) {
                            case 106:
                                this.headline = 'COMMON.LOGIN.APP_URL_CHANGED_TO';
                                this.headlineDetail = (data?.response_detail || '').toUpperCase();
                            break;
                            case 113:
                                this.headline = 'COMMON.LOGIN.MULTIPLE_ACCOUNTS_WITH_EMAIL';
                                this.headlineDetail = this.$filter('translate')('COMMON.LOGIN.PLEASE_USE_USERNAME');
                            break;
                            default:
                                this.headline = 'COMMON.LOGIN.NO_MATCH';
                                this.headlineDetail = '';
                        }
                }
            });
        }
    }

    initHeadline() {
        this.headlineClass = 'md-headline';
        this.headline = this.$state.current.params.headline;
        this.headlineDetail = '';
    }

    resolveError(err) {
        this.$ngRedux.dispatch({ type: LOADING, data: false });
        this.headlineClass = 'md-headline-error';
        if (err.status === 401) {
            this.headline = 'Unauthorized Access';
            this.headlineDetail = 'Please check your credentials';
        } else {
            this.headline = 'System Error';
            this.headlineDetail = 'Please try again later';
        }
    };
}

AuthLoginController.$inject = ['$log', '$ngRedux', '$state', '$filter', '$uiRouterGlobals', 'AuthService', 'AppService'];

export const authLogin =  {
    controller: AuthLoginController,
    template: require('./auth-login.html')
};
